export default "__VITE_ASSET__BUH2j23j__"